import classNames from 'classnames'

interface NewBadgeProps {
  className?: string
  size?: 'sm' | 'md'
}

/**
 * A "Yeni" (New) badge to highlight new features.
 * Use this on new features to draw user attention.
 * 
 * Remove the badge after ~2-3 weeks or when a new version is released.
 */
const NewBadge = ({ className, size = 'sm' }: NewBadgeProps) => {
  return (
    <span
      className={classNames(
        'inline-flex items-center font-bold uppercase tracking-wide',
        'bg-gradient-to-r from-rose-500 to-pink-500 text-white rounded-full',
        'animate-pulse',
        {
          'text-[10px] px-1.5 py-0.5': size === 'sm',
          'text-xs px-2 py-0.5': size === 'md',
        },
        className
      )}
    >
      Yeni
    </span>
  )
}

export default NewBadge

